import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="clear-input"
export default class extends Controller {
  static targets = ["input"];

  connect() {}

  clear() {
    this.inputTarget.value = "";
    this.inputTarget.focus();
  }
}
